import { render, staticRenderFns } from "./TemplateNumberDlg.vue?vue&type=template&id=2fbfd65c"
import script from "./TemplateNumberDlg.vue?vue&type=script&lang=js"
export * from "./TemplateNumberDlg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports